export type OffersProductView = 'forfaits' | 'credits' | 'gifts' | 'club';

export const OFFERS_PRODUCT_PATHS: Record<OffersProductView, string> = {
  forfaits: '/app/forfaits',
  credits: '/app/credits',
  gifts: '/app/cartes-cadeaux',
  club: '/app/abonnements',
};
